import { FuelGridContainer } from '@frete.com/fuel-react';
import styled from 'styled-components';

export const Container = styled(FuelGridContainer)`
  padding-bottom: ${({ theme }) => theme.spacing.km12};
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`;

export const Session = styled.div`
  width: 100%;
`;
